/** The AI budget form's fields, reset whenever the saved budget changes. */

import { useCallback, useEffect, useState } from 'react';

import type { Budget } from '@/api/types';

export function useBudgetForm(budget: Budget) {
  const [limit, setLimit] = useState(String(Number(budget.limit_usd)));
  const [threshold, setThreshold] = useState(budget.alert_threshold_pct);
  const [hardStop, setHardStop] = useState(budget.hard_stop);
  const reset = useCallback(() => {
    setLimit(String(Number(budget.limit_usd)));
    setThreshold(budget.alert_threshold_pct);
    setHardStop(budget.hard_stop);
  }, [budget]);
  useEffect(reset, [reset]);

  const changed =
    Number(limit) !== Number(budget.limit_usd) || threshold !== budget.alert_threshold_pct || hardStop !== budget.hard_stop;

  return { limit, setLimit, threshold, setThreshold, hardStop, setHardStop, changed, reset };
}

export type BudgetFormState = ReturnType<typeof useBudgetForm>;
